import { Pipe, PipeTransform } from '@angular/core';
import { Nillable } from '@web/utils';
import { catchError, isObservable, map, Observable, of, startWith } from 'rxjs';

type LoadingState<T, E> =
  | { loading: true; value?: T; error?: E }
  | { loading: false; value?: T; error: E }
  | { loading: false; value: T; error?: E };

@Pipe({
  name: 'withLoading',
  standalone: true,
})
export class WithLoadingPipe implements PipeTransform {
  public transform<T, E = Error>(
    value: Nillable<Observable<T>>,
  ): Nillable<Observable<LoadingState<T, E>>> {
    return isObservable(value)
      ? value.pipe(
          map((value: T) => ({ loading: false, value }) as LoadingState<T, E>),
          startWith({ loading: true } as LoadingState<T, E>),
          catchError((error: E) =>
            of({ loading: false, error } as LoadingState<T, E>),
          ),
        )
      : value;
  }
}
